export default {"src":"https://wp-static.smartkarma.com/_next/static/media/empty-state-news.14f56aa4.svg","height":92,"width":86,"blurWidth":0,"blurHeight":0};